export default __webpack_public_path__ + "static/media/winset-logo.3ec61eeb.png";